import { render, staticRenderFns } from "./wangEdit.vue?vue&type=template&id=19fb4540&scoped=true"
import script from "./wangEdit.vue?vue&type=script&lang=js"
export * from "./wangEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb4540",
  null
  
)

export default component.exports